import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-slate-900 py-16 md:py-24 lg:py-32 min-h-[80vh] flex items-center" data-id="element-199">
      {/* Video Background */}
      <div className="absolute inset-0 z-0" data-id="element-200">
        <div className="absolute inset-0 bg-slate-900/60 z-10" data-id="element-201"></div>{' '}
        {/* Dark overlay for text readability */}
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://images.unsplash.com/photo-1483664852095-d6cc6870702d?q=80&w=2070&auto=format&fit=crop" // Fallback image
      data-id="element-202">
          {/* Using the user provided video */}
          <source src="https://cdn.magicpatterns.com/uploads/gVfFpdrefsXLf2ttSaXFT7/2e5fd22b26ef49c6ad1f7e7527a79d9f.undefined" type="video/mp4" data-id="element-203" />
          Your browser does not support the video tag.
        </video>
        {/* Fallback gradient if video fails to load or while loading */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 -z-10" data-id="element-204"></div>
      </div>

      {/* Decorative elements - adjusted for video bg */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 h-96 w-96 rounded-full bg-primary/20 blur-3xl z-10 mix-blend-screen" data-id="element-205"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 h-96 w-96 rounded-full bg-blue-600/20 blur-3xl z-10 mix-blend-screen" data-id="element-206"></div>

      <div className="container relative z-20 mx-auto px-4 md:px-6" data-id="element-207">
        <div className="max-w-4xl mx-auto text-center space-y-8 animate-in fade-in slide-in-from-bottom-8 duration-1000" data-id="element-208">
          <div className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary-foreground backdrop-blur-sm mx-auto" data-id="element-209">
            <span className="flex h-2 w-2 rounded-full bg-primary mr-2 animate-pulse" data-id="element-210"></span>
            Serving All of Ontario
          </div>

          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl drop-shadow-lg" data-id="element-211">
            Never Shovel Snow Again
          </h1>

          <p className="max-w-2xl mx-auto text-lg text-slate-200 md:text-xl drop-shadow-md" data-id="element-212">
            Experience the luxury and safety of a fully automated heated
            driveway. Protect your family from slips and falls while adding
            value to your home.
          </p>

          <div className="flex flex-col gap-4 sm:flex-row justify-center" data-id="element-213">
            <Button size="lg" className="text-base shadow-lg shadow-primary/20 hover:shadow-primary/40 transition-all duration-300 hover:scale-105" onClick={() => document.getElementById('quote-form')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-214">
              Get Your Free Quote
              <ArrowRight className="ml-2 h-4 w-4" data-id="element-215" />
            </Button>
            <Button variant="outline" size="lg" className="bg-white/5 text-white border-white/20 hover:bg-white/20 hover:text-white backdrop-blur-sm transition-all duration-300" onClick={() => document.getElementById('how-it-works')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-216">
              How It Works
            </Button>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:gap-6 text-sm text-slate-300 font-medium justify-center pt-4" data-id="element-217">
            <div className="flex items-center justify-center gap-2" data-id="element-218">
              <CheckCircle2 className="h-4 w-4 text-primary" data-id="element-219" />
              <span data-id="element-220">Ontario's Heating Experts</span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-221">
              <CheckCircle2 className="h-4 w-4 text-primary" data-id="element-222" />
              <span data-id="element-223">Professional Installation</span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-224">
              <CheckCircle2 className="h-4 w-4 text-primary" data-id="element-225" />
              <span data-id="element-226">Warranty Protection</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}